import React from "react";
import { PostConfigData, VotesConfigData } from "../Shared/Party/PartyConfigData";
import { StateManagerContext } from "./StateManagerContext";
import { UIConfigContext } from "./UIConfigContext";
import { LikesButton, LikesButtonProps } from "./LikesButton";
import { VoteCounterDisplay, VoteCounterProps } from "./VoteCounter";
import { ActionButton, ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";

export type CommentButtonPanelProps = {
  height: number;
  width: number;
  voting: VotesConfigData;
  keyIndex: string;
  commentButton: boolean;
  commentClickHandler: ActionHandler;
  useSignInOverlay? : boolean;
}

export const CommentButtonPanel = ({ height, width, voting, keyIndex, commentButton, commentClickHandler, useSignInOverlay }: CommentButtonPanelProps): React.JSX.Element => {

  const stateManager = React.useContext(StateManagerContext);
  const uiConfig = React.useContext(UIConfigContext);


  //const votingState = post.voting !== undefined ? state.currentElement().voting() : state.voting();
  if (voting !== undefined) {

    const buttonWidth = commentButton ? ((width - 30) * 0.33) : ((width - 35) * 0.5);

   

    const likesProps: LikesButtonProps = {
      width: buttonWidth,
      height: height,
      matchExpression: false,
      voting: voting,
      background: 'black',
      radius: 10,
      fontBase: uiConfig.fontBase,
      unlike: false,
      likeStatus: (status: boolean) => { uiConfig.likeChange(voting.itemId, status); },
      format: 'row'

    }

    const commentProps: VoteCounterProps = {
      voting: voting,
      voteType: 'comments',
      matchExpression: false,
      fontBase: uiConfig.fontBase,
      direction: 'row',
      justify: 'left',
      padding: 5,
      textFirst: false,
    }



    const commentAction = CreateAction('commentAction', [{ permission: 'signedIn' }], commentClickHandler);
    commentAction.useSignInOverlay = useSignInOverlay;

    const commentButtonStyling: FanboxStyling = {
      width: buttonWidth,
      height: height,
      color: {
        foreground: 'white',
        background: 'black'
      },
      boundary: {
        radius: 10,
      },
      font: {
        size: uiConfig.fontBase,
        weight: 'regular'
      }
    }


    return (
      <div style={{
        width: width + "px",
        minWidth: width + "px",
        maxWidth: width + "px",
        height: height + "px",
        minHeight: height + "px",
        maxHeight: height + "px",
        display: 'flex',
        flexDirection: 'row'
      }}
      >


        <div style={{ marginLeft: "10px", marginRight: "5px" }}>
          <LikesButton {...likesProps} key={keyIndex + "likesCounter"} />
        </div>
        <div style={{ marginLeft: "10px", marginRight: "5px" }}>
          <div style={{
            backgroundColor: "black",
            borderRadius:  "10px",
            width: buttonWidth + "px",
            minWidth: buttonWidth + "px",
            maxWidth: buttonWidth + "px",
            height: height + "px",
            maxHeight: height + "px",
            minHeight: height + "px",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            position: 'relative'
          }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>

              <VoteCounterDisplay {...commentProps} key={keyIndex + "commentsCounter"} />
            </div>
          </div>
        </div>
        {commentButton && <ActionButton action={commentAction} actionData={EmptyActionData} styling={commentButtonStyling} text="Add Comment" prompt={'left'} />}
       
      </div>
    );
  }
  else
    return <div></div>
}
